export default __webpack_public_path__ + "static/media/Group9191.2d6c5a2a.svg";